import React, {useEffect} from "react"
import "../../main.scss"
import {getDocumentTitle} from "../../utils/documentTitle";
import {Prissoknad, usePrissoknader} from "../../api/prissoknader";
import {classes} from "../../utils/utils";
import LoadingSpinner from "../../components/LoadingSpinner";
import {AlertError} from "../../components/Alert/alerts";
import styles from "./styles.module.scss"
import {useParams} from "react-router-dom";
import PrissoknadListItem from "./PrissoknadListItem";
import {PktAlert} from "@oslokommune/punkt-react";

function Barnehageprissoknad() {
    useEffect(() => {
        window.scrollTo(0, 0)
        document.title = getDocumentTitle('pris-søknad')
    })
    const {id} = useParams()
    if (!id) throw Error('Missing id')
    const [prissoknader, prissoknaderStatus] = usePrissoknader()

    const prissoknad = prissoknader?.find((soknad) => soknad.brukerreferanse === id) as Prissoknad | undefined

    return (
        <div className="pkt-cell pkt-cell--span12">
            <div className="px-size-8 px-size-16--phablet-up">
                <div className="mx-size-8 mx-size-8--tablet-up my-size-24 my-size-64--tablet-up">
                    <h1 className="pkt-txt-36 pkt-txt-40--tablet-up">
                        Søknad om redusert barnehagepris
                    </h1>
                </div>
                <div className={styles.soknadListContainer}>
                    <div className={classes(styles.soknadListHeader, styles.headerText)}>
                        <span className={classes(styles.flexColumn)}>Dato</span>
                        <span className={classes(styles.flexColumn)}>Søknadstype</span>
                        <span className={classes(styles.flexColumn)}>Innsendt av</span>
                        <span className={classes(styles.flexColumn, styles.includeOnLargeScreen)}>Status</span>
                    </div>
                    {prissoknaderStatus === 'ready' && prissoknad === undefined && (
                        <PktAlert skin={"warning"} className={"mt-size-16"}>
                            Vi fant ikke søknaden din med brukerreferanse {id}.
                        </PktAlert>
                    )}

                    {prissoknaderStatus === 'ready' && prissoknad && (
                        <PrissoknadListItem prissoknad={prissoknad}/>)}
                </div>

                {prissoknaderStatus === 'pending' && <LoadingSpinner/>}

                {prissoknaderStatus === 'error' && <AlertError/>}
            </div>
        </div>
    )
}

export default Barnehageprissoknad
